import { HttpRequest } from './HttpRequest'

export interface IPdpaResponse {
    message: string
    responseData: IPdpaData
    error: any
}

export interface IPdpaData {
    collection: IPdpaCollection[]
    identifierLists: IPdpaIdentityLists[]
}

export interface IPdpaCollection {
    id: string
    status: string
    languages: IPdpaCollectionLanguages[]
}

export interface IPdpaCollectionLanguages {
    name: string
    description: string
    language: string
}

export interface IPdpaIdentityLists {
    identifier: string
    completePurpose: string
    purposes: IPdpaIdentityListsPurpose[]
}

export interface IPdpaIdentityListsPurpose {
    id: string
    status: string
}


export const GetPdpaByEmailLists = async (objectSearch: any) => {
    let data = JSON.stringify(objectSearch)
    try {
        const response = await HttpRequest().post(`/pdpa/purposes`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

export const GetPdpaByProspectId = async (objectSearch: any) => {
    let data = JSON.stringify(objectSearch)
    try {
        const response = await HttpRequest().post(`/pdpa/purposes`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}

